import axios, { Method, AxiosResponse } from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BOSAGORA_API_URL,
});

const request = <T>(
  method: Method,
  url: string,
  params?: any
): Promise<AxiosResponse<T>> => {
  return api.request<T>({
    method,
    url,
    data: params ? JSON.stringify(params) : null,
  });
};

export default request;
